<template>
  <div class="card-divider"
       :class="{ 'mb-0': noMargin,
                 'card-divider-no-padding mx-0': noBodyPadding }" />
</template>

<script>

export default {
  name: "CardDivider",

  props: {
    noMargin: { type: Boolean, default: false },
    noBodyPadding: { type: Boolean, default: false }
  }
};
</script>
